import stylesheet from './ImageCard.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTImageCard extends CustomComponent {
    static observedAttributes = ['aspect-ratio'];

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get aspectRatio() {
        if( this.hasAttribute('aspect-ratio')) {
            return this.getAttribute('aspect-ratio');
        } else {
            return '4 / 3';
        }
    }

    render() {
        const card = document.createElement('div');
        card.classList.add('card');
        card.style.setProperty('--aspect-ratio', this.aspectRatio);
        card.innerHTML = `
            <div class="image"></div>
            <div class="title"></div>
            <div class="body"></div>
            <div class="cta">
                <slot name="cta"></slot>
            </div>
        `;
        this.cloneDefaultSlotContentIntoContainer(card.querySelector('.body'));
        const imageContainer: HTMLElement = card.querySelector('.image');
        this.cloneSlotContentIntoContainer(imageContainer, 'image');
        this.preventImgDraggable(imageContainer);
        this.cloneSlotContentIntoContainer(card.querySelector('.title'), 'title');
        return card;
    }

    preventImgDraggable(container: HTMLElement) {
        container.querySelectorAll('img').forEach(img => {
            img.setAttribute('draggable', 'false');
        });
    }

}

customElements.define('nxt-image-card', NXTImageCard);
